/* eslint-disable max-len */
export default {
    products: {
        sku: 'Product code',
        productName: 'Product name',
        quantity: 'Quantity of goods',
        productCommentClient: "Client's comment",
        productPrice: 'Price per piece',
        productPriceRegular: 'Price per piece with loyalty card',
        sum: 'Amount per position',
        productProperties: 'Specifications',
        sumWithDiscount: 'Amount per position (including points)',
    },

    print: {
        title: 'Print order',
        titleWait: 'Formation task is being created, please wait',
        button: 'Order Printing',
        defaultTitleModal: 'Print the order?',
        assemblyTitleModal: 'Start assembling the order?',
        okTitleModal: 'Ok',
        cancelTitleModal: 'Cancel',
        textInfo: '<span>Attention!</span> <span>Be sure</span> to create an order in the CRM before scanning the soft receipt at the checkout. If you don\'t create an order, an error <span> "Receipt not found" </span> will be displayed at the checkout.',

        addItemToReceipt: "The 'Add item to receipt' function is not available. Adding a new product position only by separate check.",
        printDocs: 'Printing documents',

        docDefinition: {
            text1: 'Order № {id}',
            text2: 'Order № {id} from {dateCreate}',
            text3: 'Attention there is a loyalty program Card in the order.',
            text4: 'To sell at the checkout separately!',
            text5: 'Upon presentation of the Fix Price card at the checkout, the cost of goods \n' +
          'can be recalculated taking into account the promotion "Special price on the card"',
        },

        body: {
            text1: "Comment on the customer's order:",
            text2: 'Delivery method:',
            text3: "Comment on the employee's order:",
            text4: 'Delivery address:',
            text5: "Client's name:",
            text6: 'Desired delivery date:',
            text7: 'Coordination of changes with the client:',
            text8: "Customer's contact phone number:",
            text9: 'Payment methods:',
            text10: 'Payment status:',
            text11: 'Partner\'s order number',
            text12: '№ partner\'s order',
        },

        getTotal: {
            text1: 'Total: {totalSum}',
            text2: 'Discount amount: {totalSaleSum}',
            text3: 'Ordered (products): {totalSumOriginal}',
            text4: 'Total (goods): {totalSum}',
            text5: 'Shipping cost (from the order): {deliverySumClient}',
            text10: 'Promo code discount: {promocode}',
            totalWithPromocode: 'Total including promo code: {sum}',
            totalDelivery: 'Total collected (including shipping): {totalDelivery}',
            totalWithDiscount: 'Total collected (including discount and shipping): {totalWithDiscount}',
            totalWithPackages: 'Total collected (including packages and shipping): {totalWithPackages}',
            totalWithDicountAndPackages: 'Total collected (including rebate, packages and shipping): {totalWithDicountAndPackages}',
            packageSum: 'Package cost: {packageSum}',
        },
    },

    printActlssuing: {
        products: {
            sku: 'Product code',
            productName: 'Product name',
            quantity: 'Quantity of goods',
            productCommentClient: "Client's comment",
            productPrice: 'Price per piece (including VAT)',
            sum: 'Amount per position with VAT',
            productProperties: 'Specifications',
        },

        printTable: 'Acceptance certificate',

        button: 'The act of issuing the order',

        docDefinition: {
            text1: 'The act of acceptance and transfer of the order № {id}',
            text2: 'Order № {id} from {dateCreate}',
            text3: 'Attention there is a loyalty program Card in the order.',
            text4: 'To sell at the checkout separately!',
        },

        getMainInfo: {
            text1: "Comment on the customer's order:",
            text2: 'Delivery method:',
            text3: "Comment on the employee's order:",
            text4: 'Delivery address:',
            text5: "Client's name:",
            text6: 'Desired delivery date:',
            text7: 'Coordination of changes with the client:',
            text8: "Customer's contact phone number:",
            text9: 'Payment methods:',
            text10: 'Payment status:',
            text11: 'Store address:',
        },

        getTotal: 'Total: {totalSum} (with VAT) \n\n',

        getAgreementText: '1. The buyer has no claims to the product he accepted from the online store \n 2. This Act is drawn up in Russian in two copies having equal legal force, one copy for each Party.\n',

        getPlaceForSignature: {
            text1: 'From the Seller',
            text2: 'From the Buyer',
            text3: 'Post',
        },

        getFinalAgreementText: 'If any product did not suit you, you can return it within 7 calendar days or exchange it within 14 calendar days in accordance with the legislation of the Russian Federation (ZOZPP No2300-1) and the Terms of Sale posted on the website. You can deliver the goods after receiving the order by naming the order number in which the goods came to you and providing a printed or electronic order receipt. Refund: If you paid for the order online, the money for the goods will be credited to the bank card that you used when placing the order. The refund of funds to the card is carried out within 10 days from the date of application. If you paid for the goods in cash upon receipt of the order, the money for the goods will be returned to you in cash at the checkout of the store.',
    },
};